import { Component, Host, Prop, h } from '@stencil/core';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isToday from 'dayjs/plugin/isToday';
dayjs.extend(customParseFormat);
dayjs.extend(isToday);

export interface AhaEventListGroupHeading extends HTMLAhaEventListGroupHeadingElement {}

@Component({
  tag: 'aha-event-list-group-heading',
  styleUrl: 'aha-event-list-group-heading.css',
  shadow: true,
})
export class AhaEventListGroupHeading {
  /** The date to be shown. Must be in format YYYY-MM-DD. */
  @Prop({ reflect: true }) date!: string;
  /** Whether it is highlighted or not */
  @Prop({ reflect: true }) highlight!: boolean;

  render() {
    const date = dayjs(this.date, 'YYYY-MM-DD');
    const diffDays = dayjs(this.date).startOf('day').diff(dayjs().startOf('day'), 'days');
    const selectedDateName = (() => {
      if (dayjs(this.date).isSame(dayjs(), 'week')) {
        switch (diffDays) {
          case 0:
            return 'Today';
          case -1:
            return 'Yesterday';
          case 1:
            return 'Tomorrow';
          default:
            return dayjs(this.date).format('dddd');
        }
      }
    })();

    return (
      <Host>
        <div class="event-list-date">
          <span class="date">
            <aha-date date={date.format('YYYY-MM-DD')} format="long"></aha-date>
          </span>
          {selectedDateName && <span>({selectedDateName})</span>}
        </div>
        <div>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
